import { call, put } from 'redux-saga/effects';
import { IOrderSimulateState, ISalesParams, Types } from './types';
import { confirmedSale, confirmSaleFailure } from './actions';
import { CheckoutServiceMvp } from '../../../services/CheckoutMvp';

interface IOrdersSentParam {
  payload: {
    params: ISalesParams;
  };
  type: Types;
}
interface ICheckoutStateParam {
  payload: {
    params: IOrderSimulateState;
  };
  type: Types;
}

export function* updateCheckoutStateLocalStorage(data: ICheckoutStateParam) {
  const { params } = data.payload;

  const checkoutServiceMvp = new CheckoutServiceMvp();
  yield call(
    checkoutServiceMvp.updateCheckoutStateLocalStorage.bind(checkoutServiceMvp),
    params
  );
}

export function* requestOrdersSentSaga(data: IOrdersSentParam) {
  const { params } = data.payload;

  try {
    const checkoutServiceMvp = new CheckoutServiceMvp();
    const data: string[] = yield call(
      checkoutServiceMvp.sendOrder.bind(checkoutServiceMvp),
      params
    );
    yield put(confirmedSale(data));
  } catch (err) {
    const errorMessage =
      err instanceof Error ? err.message : 'Falha ao confirmar pedido.';
    yield put(confirmSaleFailure(errorMessage));
  }
}
